module.exports = __webpack_public_path__ + "img/work.46ead0ea.svg";